import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  TextField,
} from '@mui/material';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const AccountDeletionDialog = ({ deleting, onClose, onConfirm, open }) => {
  const { t } = useTranslation();
  const confirmationPhrase = t('profile.delete.confirmationPhrase');
  const translatedDeletedItems = t('profile.delete.deletedItems', { returnObjects: true });
  const deletedItems = Array.isArray(translatedDeletedItems) ? translatedDeletedItems : [];
  const [confirmation, setConfirmation] = useState('');

  useEffect(() => {
    if (!open) {
      setConfirmation('');
    }
  }, [open]);

  const confirmed = confirmation === confirmationPhrase;

  return (
    <Dialog
      open={open}
      onClose={() => {
        if (!deleting) onClose();
      }}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>{t('profile.delete.dialogTitle')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('profile.delete.dialogBody')}</DialogContentText>
        <List dense sx={{ mt: 1.5, mb: 1.5 }}>
          {deletedItems.map((item) => (
            <ListItem key={item} disableGutters sx={{ py: 0.25 }}>
              <ListItemText primary={item} />
            </ListItem>
          ))}
        </List>
        <DialogContentText sx={{ mb: 1 }}>
          {t('profile.delete.confirmationPrompt')}
        </DialogContentText>
        <TextField
          autoComplete="off"
          disabled={deleting}
          fullWidth
          label={t('profile.delete.confirmationLabel')}
          onChange={(event) => setConfirmation(event.target.value)}
          value={confirmation}
          helperText={t('profile.delete.confirmationHelper', {
            phrase: confirmationPhrase,
          })}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={deleting}>
          {t('common.cancel')}
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          disabled={deleting || !confirmed}
          startIcon={
            deleting ? <CircularProgress color="inherit" size={18} /> : <DeleteForeverOutlinedIcon />
          }
        >
          {deleting ? t('profile.delete.deleting') : t('profile.delete.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AccountDeletionDialog;
